import UrlHelpers from "./url";

export class OrderWizardLandingPage {

    constructor() {

        (<HTMLButtonElement>document.getElementById('landingPage_content_btn_startWizard')).addEventListener('click', (e: Event) => {
            window.top.location.href = (<HTMLElement>e.target).dataset['target'];
        });

        this._googlePageView();

        window.addEventListener('load', () => {
            this._showLandingPageContent();
        })
    }

    private _showLandingPageContent = () => {
        const content = <HTMLElement>document.getElementById('landingPage_content');
        if (!content) {
            console.log('cannot find element \'content\'');
            return;
        }
        content.style.display = 'block';
    };

    private _googlePageView = () => {
        if (!UrlHelpers.getMetaData("gtmActive") || UrlHelpers.getMetaData('sysAdmin')) {
            return;
        }
        const gtmValues = {pagePath: '/center/subscription/landingPage', pageTitle: 'Landing Page'};
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push({
            'event': 'Pageview',
            'pagePath': gtmValues.pagePath,
            'pageTitle': gtmValues.pageTitle
        });
    };
}